export enum DatiqCellLocationPosition {
    Origin = 'app:origin',
    Destination = 'app:destination',
    Unknown = '',
}
